<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 13:52:03
 * @LastEditTime: 2020-11-21 18:38:06
 * @LastEditors: wutt
 -->
<!--  -->
<template>
  <div class="div_map">
    <div id="map" class="div_map">

      <UCAptitude></UCAptitude>

    </div>

    <UCMapOverlay ref="ucOverlay"></UCMapOverlay>

  </div>

</template>


<script>
import UCMapOverlay from "./UCMapOverlay.vue";
import UCAptitude from "./UCAptitude.vue";
import { LayerManager } from "./layer/LayerManager.js";
import { OLMapUtility } from "../../../utility/common/OLMapUtility";

import { UCMapEvent } from "./UCMapJs.js";
import { MapBaseLayer } from "./layer/MapBaseLayer";
import { MapBaseLayerEx } from "./layer/MapBaseLayerEx.js";

// import { LayerFeatureType } from './layer/LayerFeatureType';

export default {
  name: "UCMap",

  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
  },

  data() {
    return {
      curMap: null,

      //图层管理
      layerMgr: null,

      currentMapLevel: -1,
    };
  },

  components: { UCMapOverlay, UCAptitude },

  computed: {},

  mounted() {
    // this.$nextTick(() => {
    //   this.initMap(); // 初始化地图
    // });
  },

  methods: {
    //初始化
    init(mapOptions, showMapControl) {
      this.layerMgr = new LayerManager();
      this.layerMgr.baseLayer = new MapBaseLayer();
      //初始化底图配置
      this.layerMgr.initBaseLayerConfig();

      let newMapControl = new EzMap("map", mapOptions);

      if (showMapControl) {
        newMapControl.showMapControl();
      }

      this.curMap = newMapControl;

      this.layerMgr.currentMap = this.curMap;
      this.layerMgr.ucMapOverLay = this.$refs.ucOverlay;
      this.layerMgr.init();
      this.layerMgr.addLayers();

      this.$refs.ucOverlay.curMap = this.curMap;
      this.$refs.ucOverlay.init();

      this._initEvents();
    },
    /**
     * @Author: wutt
     * @Date: 2020-11-19 09:58:21
     * @Description: 根据运维管理底图配置初始化底图
     * @param {*} mapOptions
     * @param {*} showMapControl
     */
    initEx(mapOptions, showMapControl,callback) {
      let self = this;
      this.layerMgr = new LayerManager();
      this.layerMgr.baseLayer = new MapBaseLayerEx();
      this.layerMgr.baseLayer.init(() => {
        //初始化底图配置
        self.layerMgr.initBaseLayerConfigEx();

        let newMapControl = new EzMap("map", mapOptions);

        if (showMapControl) {
          newMapControl.showMapControl();
        }

        self.curMap = newMapControl;

        self.layerMgr.currentMap = self.curMap;
        self.layerMgr.ucMapOverLay = self.$refs.ucOverlay;
        self.layerMgr.init();
        self.layerMgr.addLayers();

        self.$refs.ucOverlay.curMap = self.curMap;
        self.$refs.ucOverlay.init();
        self._initEvents();
        callback();       
      });
    },

    on_mapClick(callback) {
      if (callback) {
        this.curMap.on("click", callback);
      }
    },

    on_rightClick(callback) {
      let viewPort = this.curMap.getViewport();
      viewPort.addEventListener("contextmenu", callback);
    },

    on_ucOverlay_getSurroundInfoFinished(callback) {
      if (callback) {
        this.$refs.ucOverlay.on_getSurroundInfoFinished(callback);
      }
    },

    on_ucOverlay_on_saveDrawGeometry(callback) {
      if (callback) {
        this.$refs.ucOverlay.on_saveDrawGeometry(callback);
      }
    },

    on_ucOverlay_on_deleteDrawGeometry(callback) {
      if (callback) {
        this.$refs.ucOverlay.on_deleteDrawGeometry(callback);
      }
    },

    on_ucOverlay_selectCollectFolderFinished(callback) {
      if (callback) {
        this.$refs.ucOverlay.on_selectCollectFolderFinished(callback);
      }
    },

    on_ucOverlay_mapRightButton_getPOIInfoFinished(callback) {
      if (callback) {
        this.$refs.ucOverlay.on_mapRightButton_getPOIInfoFinished(callback);
      }
    },

    /**
     * 全屏
     */
    fullscreen() {
      let divElement = document.getElementById("map");

      if (divElement.requestFullscreen) {
        divElement.requestFullscreen();
      } else if (divElement.mozRequestFullScreen) {
        divElement.mozRequestFullScreen();
      } else if (divElement.webkitRequestFullscreen) {
        divElement.webkitRequestFullscreen();
      } else if (divElement.msRequestFullscreen) {
        divElement.msRequestFullscreen();
      }
    },

    /**
     * 退出全屏
     */
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },

    on_mapPointerMove(callback) {
      if (callback) {
        this.curMap.on("pointermove", callback);
      }
    },

    on_zoomLevelChange(callback) {
      if (callback) {
        this.$on(UCMapEvent.UCMap_event_zoomlevelChange, callback);
      }
    },

    on_moveend(callback) {
      if (callback) {
        this.curMap.on("moveend", callback);
      }
    },

    //获取地图
    getMap() {
      return this.curMap;
    },

    /**
     * 获取分辨率
     */
    getResolution() {
      return this.curMap.getView().getResolution();
    },

    setCenter(zoom, centerPnt) {
      this.curMap.getView().setZoom(zoom);
      this.curMap.getView().setCenter(centerPnt);
    },

    setMapExtent(mapExtent) {
      let mapView = this.curMap.getView();
      mapView.fit(mapExtent, {
        nearest: true,
      });
    },

    setZoomLevel(level) {
      let mapView = this.curMap.getView();
      mapView.setZoom(level);
    },

    plusZoomLevel() {
      let zoomLevel = this.getZoomLevel();
      let plusLevel = zoomLevel + 1;
      this.setZoomLevel(plusLevel);
    },

    subtractionZoomLevel() {
      let zoomLevel = this.getZoomLevel();
      let subtractionLevel = zoomLevel - 1;
      this.setZoomLevel(subtractionLevel);
    },

    //获取地图范围
    getMapExtent() {
      let mapView = this.curMap.getView();
      let curMapSize = this.curMap.getSize();
      let mapExtent = mapView.calculateExtent(curMapSize);
      return mapExtent;
    },

    getZoomLevel() {
      let mapView = this.curMap.getView();
      let zoomLevel = mapView.getZoom();
      return zoomLevel;
    },

    getProjectionCode() {
      let projectCode = OLMapUtility.getProjectionCode(this.curMap);
      return projectCode;
    },

    showOverlay(position, feature) {
      if (this.$refs.ucOverlay) {
        this.$refs.ucOverlay.showOverlay(position, feature);
      }
    },

    hideOverlay() {
      if (this.$refs.ucOverlay) {
        this.$refs.ucOverlay.hideOverlay();
      }
    },

    clearOverlays() {
      if (this.$refs.ucOverlay) {
        this.$refs.ucOverlay.clearOverlays();
      }
    },

    _initEvents() {
      let self = this;

      this.curMap.on("moveend", function () {
        let curZoomLevel = self.curMap.getView().getZoom();
        if (curZoomLevel != self.currentMapLevel) {
          self.$emit(UCMapEvent.UCMap_event_zoomlevelChange, curZoomLevel);
        }

        self.currentMapLevel = curZoomLevel;
      });
    },

    // addBaseLayer() {}
  },
};
</script>

<style lang="scss" scoped>
.div_map {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  // background: #0f1467;
  background: #f6f6f4;
}
</style>
